import { Component } from "react";

/**
 * App-wide safety net. Without this, any uncaught error thrown during render or
 * inside an effect (e.g. touching an API a particular browser doesn't expose)
 * unmounts the entire React tree and leaves a blank white screen with no clue
 * as to what happened. This catches that and shows a recoverable fallback while
 * logging the real error to the console for diagnosis.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("App crashed (caught by ErrorBoundary):", error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="fixed inset-0 flex items-center justify-center bg-background text-text_primary px-6">
        <div className="max-w-sm w-full text-center">
          <h1 className="text-lg font-semibold mb-2">Something went wrong</h1>
          <p className="text-sm text-text_muted mb-6">
            The app ran into an unexpected error. Reloading usually fixes it.
          </p>
          <button
            onClick={this.handleReload}
            className="bg-primary hover:bg-primary_hover text-white text-sm font-semibold py-2.5 px-5 rounded-xl transition-colors duration-150"
          >
            Reload app
          </button>
        </div>
      </div>
    );
  }
}
